const api = {
  GET_LIST_INQUIRY_MERCHANT: '/index.php?r=api/v1/system_log/service-log/inquiry-merchant',
};

export default api;
